/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menuhiddenbadge2Inputs */

const en_menuhiddenbadge2 = /** @type {(inputs: Menuhiddenbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not visible right now`)
};

const de_menuhiddenbadge2 = /** @type {(inputs: Menuhiddenbadge2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade nicht sichtbar`)
};

/**
* | output |
* | --- |
* | "Not visible right now" |
*
* @param {Menuhiddenbadge2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menuhiddenbadge2 = /** @type {((inputs?: Menuhiddenbadge2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menuhiddenbadge2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menuhiddenbadge2(inputs)
	return de_menuhiddenbadge2(inputs)
});
export { menuhiddenbadge2 as "menuHiddenBadge" }